import { render, staticRenderFns } from "./HorseSelectionV2.vue?vue&type=template&id=7adf0a7d&"
import script from "./HorseSelectionV2.vue?vue&type=script&lang=js&"
export * from "./HorseSelectionV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports